module.exports = __webpack_public_path__ + "static/img/scene_1.e98cf7d1.png";